'use client'

// src/context/favorites/context.tsx
import { createContext } from "react";
var FavoritesContext = createContext({
  favorites: [],
  toggleFavorite: () => {
  },
  isFavorite: () => false,
  initialSlugs: []
});
var context_default = FavoritesContext;

export {
  context_default
};
//# sourceMappingURL=chunk-3EM7C2X3.mjs.map